import type { ReactNode } from "react";

type ClauseProps = {
  // Номер пункта без точки в конце: «1.1».
  n: string;
  children: ReactNode;
};

// Пункт документа: номер слева, текст справа с висячим отступом.
export const Clause = ({ n, children }: ClauseProps) => (
  <p className="grid grid-cols-[44px_minmax(0,1fr)]">
    <span className="font-mono text-[13px] leading-[1.85] text-subtle">{`${n}.`}</span>
    <span>{children}</span>
  </p>
);

// Список внутри пункта — с тем же отступом, что и текст пункта.
export const ClauseList = ({ children }: { children: ReactNode }) => (
  <ul className="-mt-1 ml-11 flex list-disc flex-col gap-1 pl-5">{children}</ul>
);
